var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-none fixe inset-0 z-modal-overlay overflow-x-hidden overflow-y-auto fixed"},[_c('div',{staticClass:"relative h-full mx-auto flex items-center justify-center z-modal"},[_c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.clickaway),expression:"clickaway"}]},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }